import type { ComboboxProps } from "metabase/ui";

export const WIDTH = 380;
export const COMBOBOX_PROPS: Partial<ComboboxProps> = {
  width: 298,
  position: "bottom-start",
};
